/* Barra fija del hub de Josefa. Se esconde cuando ya hay un formulario a la vista.
   Usa scroll + getBoundingClientRect en vez de IntersectionObserver: el tema trae
   html{height:900px} y un <scroll-animate> que dejan a IO sin disparar en algunos casos. */
(function () {
  function altoVentana() {
    var a = window.innerHeight || 0;
    if (!a) a = document.documentElement.clientHeight || 0;
    if (!a) a = (window.screen && window.screen.height) || 0;
    return a || 800;
  }

  function arrancar() {
    var barra = document.querySelector('.jvh .sticky');
    if (!barra) return;
    var zonas = [
      document.querySelector('.jvh .hero'),
      document.querySelector('#jvh-optin'),
      document.querySelector('.jvh .cierre')
    ].filter(Boolean);
    if (!zonas.length) return;

    var pendiente = false;

    function aLaVista(el) {
      var r = el.getBoundingClientRect();
      if (!r.height) return false;
      var alto = altoVentana();
      return r.top < alto * 0.85 && r.bottom > alto * 0.15;
    }

    function calcular() {
      pendiente = false;
      var hayFormulario = false;
      for (var i = 0; i < zonas.length; i++) {
        if (aLaVista(zonas[i])) { hayFormulario = true; break; }
      }
      if (hayFormulario) { barra.classList.remove('on'); }
      else { barra.classList.add('on'); }
    }

    function pedir() {
      if (pendiente) return;
      pendiente = true;
      setTimeout(calcular, 60);
    }

    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    calcular();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
